import Handlebars from '@sparta.global.vendors/handlebars';
import { requiredAttrsCheck, removeReservedAttrs, combineAttrs, buildAttrsString } from '@sparta.global.helpers/utils-helper/dist/es6.js';

// The module to be exported.
function datepicker(data, returnRawHtml) {
  const requiredAttrs = ['id'];
  const reservedAttrs = ['type', 'data-mask', 'data-gis-mask'];
  const inline = !!data.datepicker.inline;
  const calendarSkin = data.datepicker.skin || 'default-design';
  const combinableAttrs = {
    class: `datepicker${inline ? '' : ' spa-input-text'}`,
    value: '',
    autocomplete: 'off'
  };
  const applyGisMask = data.datepicker['gis-mask'];
  const {
    validationRules
  } = data;
  if (typeof applyGisMask !== 'undefined') {
    // eslint-disable-next-line no-param-reassign
    data.input.attrs['data-field-type'] = applyGisMask;
    combinableAttrs.class = `${combinableAttrs.class} gis-mask`;
  }
  if (!requiredAttrsCheck(data.datepicker.attrs, requiredAttrs).pass) {
    // Server-side only.
    const {
      missingField
    } = requiredAttrsCheck(data.datepicker.attrs, requiredAttrs);
    global.nodeModules.grunt.fail.fatal(`You are missing the required attribute ${missingField}`);
  }
  removeReservedAttrs(data.datepicker.attrs, reservedAttrs);
  combineAttrs(data.datepicker.attrs, combinableAttrs);
  const attrsStr = buildAttrsString(data.datepicker.attrs);
  const containerClasses = `
    spa-input
    spa-input--sparta2
    spa-input-box
    spa-date-input
    spa-date-input--${calendarSkin}
    spa-input--${data.skin || 'material-design'}
    ${data.containerClasses ? data.containerClasses.join(' ') : ''}
    ${data.datepicker.attrs['data-help-body'] ? 'has-help' : ''}
  `;

  // Help Icon integration.
  let helpToggleText = '';
  if (data.helpToggle) {
    helpToggleText = data.helpToggle;
  } else if (data.label) {
    helpToggleText = data.label.text;
  }
  const helpIconStyles = ['datepicker-icon-box', 'ui-datepicker-trigger'];
  let helpMarkup = '';
  const helpIconLabel = attr => {
    let helpContainerMarkup = '';
    if (!attr['data-help-body']) {
      return '';
    }
    helpIconStyles.push('toggle-trigger-help');
    const markup = `
      <span class="toggle-trigger-box">
        <button
          type="button"
          id="help-open-${data.datepicker.attrs.id}"
          aria-label="${helpToggleText}"
          class="toggle-trigger svg-button svg-button-help"
        ></button>
      </span>
    `;
    const helpContainer = `
      <div
        class="input-help"
        id="helpLayer_${data.datepicker.attrs.id}"
        role="tooltip"
        aria-hidden="true"
      >
    `;
    const helpClose = `
      <button
        type="button"
        id="help-close-${data.datepicker.attrs.id}"
        aria-label="${helpToggleText}"
        class="close-trigger svg-button"
      >&nbsp;</button>
    `;
    let helpBody = `<div class="body">${data.datepicker.attrs['data-help-body']}</div>`;
    if (data.datepicker.attrs['data-help-head']) {
      helpBody = `<div class='head'>${data.datepicker.attrs['data-help-head']}</div>${helpBody}`;
    }
    helpContainerMarkup = `${markup}${helpContainer}${helpClose}${helpBody}</div>`;
    return helpContainerMarkup;
  };
  helpMarkup = helpIconLabel(data.datepicker.attrs);

  // If required, show the asterisk.
  const inputLabelRequiredSpan = required => required ? '<span class="spa-input-label--asterisk">&nbsp;*</span>' : '';
  const datepickerStyles = ['datepicker-icon--calendar'];
  if (data.datepicker.attrs.disabled) {
    datepickerStyles.push('datepicker-icon--calendar__disabled');
  }
  let output;
  if (inline) {
    output = `
      <div class="${containerClasses}" ${data.required ? 'required aria-required="true"' : ''}>
        <div ${attrsStr}></div>
      </div>
    `;
  } else {
    let validationRulesAttr = '';
    if (validationRules) {
      const rules = JSON.stringify(validationRules).replace(/'/g, '&#39;');
      validationRulesAttr = `data-validation-rules='${rules}'`;
    }
    let labelText = `${data.label.text}${inputLabelRequiredSpan(data.required, data.asterisk)}`;
    if (data.label.adaText) {
      labelText = `${labelText} <span class="ada-hidden">${data.label.adaText}</span>`;
    }
    output = `
      <div
        class="${containerClasses} ${data.datepicker.attrs.value ? '' : 'spa-input--empty'}"
        data-calendar-skin="${calendarSkin}"
      >
        <label class="spa-input-label" for="${data.datepicker.attrs.id}">${labelText}</label>
        <input
          type="text"
          aria-describedby="${data.datepicker.attrs.id}_errorMessage ${data.datepicker.attrs.id}-hint-text"
          ${attrsStr}
          ${data.vueOptionsStr || ''}
          ${validationRulesAttr}
          ${data.required ? `required aria-required="true" ${typeof data.required === 'string' ? `data-required-error-message="${data.required}"` : ''}` : ''}
        />
        <button
          type="button"
          class="${helpIconStyles.join(' ')}"
          aria-label="${data.label.text}"
          aria-controls="ui-datepicker-div"
          aria-expanded="false"
        ><i
          for="${data.datepicker.attrs.id}"
          class="${datepickerStyles.join(' ')}"
        ></i></button>
        ${helpMarkup}
        <p id="${data.datepicker.attrs.id}-hint-text" class="spa-input-hint">${data.hintText || ''}</p>
        <div
          id="${data.datepicker.attrs.id}_errorMessage"
          class="spa-input-error-message spa-icon--error"
          aria-hidden="true"
        ></div>
      </div>
    `;
  }
  return returnRawHtml === true ? output : new Handlebars.SafeString(output);
}
datepicker.functionName = "datepicker";

export { datepicker };
